/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pass_EndingInputs */

const en_platform_pass_ending = /** @type {(inputs: Platform_Pass_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running out`)
};

const pl_platform_pass_ending = /** @type {(inputs: Platform_Pass_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kończy się`)
};

/**
* | output |
* | --- |
* | "Running out" |
*
* @param {Platform_Pass_EndingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pass_ending = /** @type {((inputs?: Platform_Pass_EndingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pass_EndingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pass_ending(inputs)
	return en_platform_pass_ending(inputs)
});